import moment from 'moment';
import demoParams from '../../__test__/demoParams';
const { demoMode, demoShortPostedId, demoLongPostedId } = demoParams;

/**
 * Returns an array of Posted Schedules.
 * @param {*} listPostedSchedules
 */
const generateListPostedScheduleArray = (listPostedSchedules) => {

  moment.tz.setDefault('America/New_York');
  // NOTE on handling annual calendar change in 1&2-day posted schedules:
  // incrementing 1-9 days from the current date [moment.()] automatically handles the case where the year crossover occurs mid-week
  return [
    { name: 'postedDayOneId', id: demoMode ? demoShortPostedId : listPostedSchedules.postedDayOneId, startDate: moment().format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayTwoId', id: listPostedSchedules.postedDayTwoId, startDate: moment().add(1, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayThreeId', id: listPostedSchedules.postedDayThreeId, startDate: moment().add(2, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayFourId', id: listPostedSchedules.postedDayFourId, startDate: moment().add(3, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayFiveId', id: listPostedSchedules.postedDayFiveId, startDate: moment().add(4, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDaySixId', id: listPostedSchedules.postedDaySixId, startDate: moment().add(5, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDaySevenId', id: listPostedSchedules.postedDaySevenId, startDate: moment().add(6, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedDayEightId', id: listPostedSchedules.postedDayEightId, startDate: moment().add(7, 'day').format('M/D/YYYY'), scheduleFormat: 1 },
    { name: 'postedTwoDaysToday', id: demoMode ? demoShortPostedId : listPostedSchedules.postedTwoDaysToday, startDate: moment().format('M/D/YYYY'), scheduleFormat: 2 },
    { name: 'postedTwoDaysTomorrow', id: listPostedSchedules.postedTwoDaysTomorrow, startDate: moment().add(1, 'day').format('M/D/YYYY'), scheduleFormat: 2 },
    { name: 'savedMd7', id: demoMode ? demoLongPostedId : listPostedSchedules.postedSevenDayId, startDate: listPostedSchedules.savedMd7, scheduleFormat: 7 },
    { name: 'savedMd9', id: demoMode ? demoLongPostedId : listPostedSchedules.postedNineDayId, startDate: listPostedSchedules.savedMd9, scheduleFormat: 9 },
  ];
}

export default generateListPostedScheduleArray;



// WEBPACK FOOTER //
// ./src/Components/Schedule/generateListPostedSchedulesArray.js